module.exports = __webpack_public_path__ + "ed1c33d78ec48f8c7081870e3cad389a.svg";